import { configureStore } from "@reduxjs/toolkit";
import userReducer from './userSlice';
import tenantReducer from './tenantSlice';
import adminReducer from './adminSlice';
import assessmentUploadReducer  from './assessmentUploadSlice';
import assessmentCreateReducer from './assessmentCreateSlice';
import assessmentViewReducer from './assessmentViewSice';
import evaluationViewReducer from './evaluationViewSlice';
import chaptersTopicsReducer from './chaptersTopicsSlice';
import teacherReducer from './teacherSlice';

// Student reducers
import studentAuthReducer from './studentAuthSlice';
import studentDashboardReducer from './studentDashboardSlice';
import studentNotificationReducer from './studentNotificationSlice';
import studentAssessmentReducer from './studentAssessmentSlice';
import studentManagementReducer from './studentManagementSlice';
import studentSubmissionReducer from './studentSubmissionSlice';
import studentProgressReducer from './studentProgressSlice';

// Rubric reducer
import rubricReducer from './rubricSlice';

// Online Assessment reducers
import onlineAssessmentReducer from './onlineAssessmentSlice';
import participantReducer from './participantSlice';

// Teacher quiz authoring (used by /quiz/create — CreateQuiz reads state.teacherQuiz)
import teacherQuizReducer from './teacherQuizSlice';

// Principal Dashboard reducer
import principalDashboardReducer from './principalDashboardSlice';

// Scan Evaluation reducer
import scanEvaluationReducer from './scanEvaluationSlice';
// V3 Review Queue reducer
import reviewQueueReducer from './reviewQueueSlice';

// Suggested Topics review queue (super-admin)
import suggestedTopicsReducer from './suggestedTopicsSlice';

export const Store = configureStore ({
     reducer : {
          user: userReducer,
          tenant: tenantReducer,
          admin: adminReducer,
          uploadAssessment: assessmentUploadReducer ,
          createAssessment: assessmentCreateReducer,
          viewAssessment: assessmentViewReducer,
          viewEvaluation: evaluationViewReducer,
          chaptersTopics: chaptersTopicsReducer,
          teacher: teacherReducer,
          rubric: rubricReducer,
          // Student reducers
          studentAuth: studentAuthReducer,
          studentDashboard: studentDashboardReducer,
          studentNotification: studentNotificationReducer,
          studentAssessment: studentAssessmentReducer,
          studentManagement: studentManagementReducer,
          studentSubmission: studentSubmissionReducer,
          studentProgress: studentProgressReducer,
          // Online Assessment reducers
          onlineAssessment: onlineAssessmentReducer,
          participant: participantReducer,
          // Teacher quiz authoring (/quiz/create)
          teacherQuiz: teacherQuizReducer,
          // Principal Dashboard
          principalDashboard: principalDashboardReducer,
          // Scan Evaluation
          scanEvaluation: scanEvaluationReducer,
          // Suggested topic review queue
          suggestedTopics: suggestedTopicsReducer,
          // V3 Review Queue
          reviewQueue: reviewQueueReducer,
     },
});

export default Store;